const DataListOptionsPersonas = () => {
  return (
    <>
        <option value="Achternaam" />
        <option value="BSN" />
        <option value="Centrumzone OV" />
        <option value="Document type" />
        <option value="Document verloopdatum" />
        <option value="Documentnummer" />
        <option value="Email" />
        <option value="Geboortedatum" />
        <option value="Geslacht" />
        <option value="Huisnummer" />
        <option value="Kaart geldig tot" />
        <option value="Land van herkomst" />
        <option value="OV-kaartnummer" />
        <option value="Postcode" />
        <option value="Straatnaam" />
        <option value="Telefoonnummer" />
        <option value="Toestemming beeldmateriaal" />
        <option value="Voornaam" />
        <option value="Woonplaats" />
    </>
  )
}

export default DataListOptionsPersonas
